import { isValid, parseISO, subMonths } from 'date-fns';

export const REGISTRATION_FRESHNESS_MONTHS = 2;

export interface PhoneConfirmationParams {
  updatedAt?: string;
  phoneConfirmedAt?: string;
  now?: Date;
}

function parseTimestamp(timestamp?: string): Date | undefined {
  if (!timestamp) {
    return undefined;
  }

  const parsed = parseISO(timestamp);

  return isValid(parsed) ? parsed : undefined;
}

export function requiresPhoneConfirmation({
  updatedAt,
  phoneConfirmedAt,
  now = new Date(),
}: PhoneConfirmationParams): boolean {
  const threshold = subMonths(now, REGISTRATION_FRESHNESS_MONTHS);

  const confirmedAt = parseTimestamp(phoneConfirmedAt);

  if (confirmedAt && confirmedAt >= threshold) {
    return false;
  }

  const registrationUpdatedAt = parseTimestamp(updatedAt);

  if (!registrationUpdatedAt) {
    return false;
  }

  return registrationUpdatedAt < threshold;
}
